import React from 'react';
import { withRouter } from 'react-router-dom';
import './Game.scss';
import PlayerProfiles from './PlayerProfiles';
import City from './City';
import EnergyContainer from './EnergyContainer';
import DiceRoll from './DiceRoll';
import PlayerCards from './PlayerCards';
import AnimationOverlay from './overlays/AnimationOverlay';
import PlayerStatsOverlay from './overlays/PlayerStatsOverlay';
import TableCards from './TableCards';
import YieldOverlay from './overlays/YieldOverlay';
import AlertOverlay from './overlays/AlertOverlay';
import { useSelector } from 'react-redux';
import { selectCurrentAnimation } from '../../redux/animationSlice';
import BuyCardOverlay from './overlays/BuyCardOverlay';
import LanguageSelector from '../LanguageSelector';
import GameAreaWithTutorial from './tutorial/GameAreaWithTutorial';
import { selectIsTutorialRunning } from '../../redux/tutorialSlice';

function Game() {
  const curAnimation = useSelector(selectCurrentAnimation);
  const isTutorialRunning = useSelector(selectIsTutorialRunning);
  const showingYieldOverlay = curAnimation && curAnimation.type === "yielding-decision";
  const animationClass = curAnimation !== null ? 'animation-' + curAnimation.type : "";

  let gameWindow;
  if (isTutorialRunning) {
    gameWindow = <GameAreaWithTutorial />;
  } else {
    gameWindow = <>
      <City />
      <PlayerProfiles />
      <PlayerCards />
      <div id="player-action-panel-container">
        <div className="center-structure">
          <DiceRoll />
          <EnergyContainer />
        </div>
        <TableCards />
      </div>
    </>;
  }

  return <div id="game">
    <AlertOverlay />
    {showingYieldOverlay ? <YieldOverlay /> : null}
    <PlayerStatsOverlay />
    <AnimationOverlay curAnimation={curAnimation} />
    <BuyCardOverlay />

    <div id="game-window" className={`noselect ${animationClass}`}>
      {gameWindow}
    </div>
    <LanguageSelector animationClass={animationClass} />
  </div>;
}

export default withRouter(Game);
